// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gSNk2","form":"styles_form__3Se9d","button":"styles_button__3JQY9","subtitle":"styles_subtitle__cLqaC"};